<template>
  <Dialog v-model:visible="visible" :modal="true" :contentStyle="{'overflow': 'visible'}"
    ref="dialog" @show="onShow()">
    <template #header>
      <div v-if="loading">Моля изчакайте...</div>
      <h2 v-if="!loading">{{title}}</h2>
    </template>
    <div v-if="loading" class="p-text-center">
      <ProgressSpinner/>
    </div>
    <div v-else>
      <slot name="default"/>
    </div>
    <template #footer>
      <div class="p-d-flex p-jc-between">
        <div><slot name="footer"/></div>
        <div>
          <Button v-if="!loading"
            label="Затвори"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="$refs.dialog.close()"
          />
          <Button v-if="!loading && labelOk"
            v-bind:label="labelOk"
            v-bind:icon="iconOk"
            class="p-button-primary"
            @click="onApply"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
export default {
  emits: {
    init: null,
    apply: null,
    shown: null,
    loaded: null,
  },
  data() {
    return {
        visible: false,
        loading: true,
        data: {}
    }
  },

  mounted() {
  },

  props: {
    title: {
      type: String,
      default: () => { return "Потвърждение" }
    },
    labelOk: {
      type: String,
      default: () => { return "Да" }
    },
    iconOk: {
      type: String,
      default: () => { return "pi pi-check" }
    },
  },

  methods: {
    onShow() {
      this.loading = true
      this.$emit('init', (data) => {
        this.loading = false
        this.data.data = data
      })
    },
    onApply() {
      this.loading = true
      this.$emit('apply', (data) => {
        this.loading = false
        this.data.data = data
      })
    }
  }
}
</script>

<style>
</style>
